import { render, staticRenderFns } from "./AddExercise.vue?vue&type=template&id=4b0c566e&"
import script from "./AddExercise.vue?vue&type=script&lang=js&"
export * from "./AddExercise.vue?vue&type=script&lang=js&"
import style0 from "./AddExercise.vue?vue&type=style&index=0&id=4b0c566e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports